var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcExclamationCircleDescription = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 14a6 6 0 1 0-.001-12.001A6 6 0 0 0 8 14Zm-.333-8.667A.33.33 0 0 1 8 5a.33.33 0 0 1 .333.333V9A.33.33 0 0 1 8 9.333.33.33 0 0 1 7.667 9V5.333ZM8 10c.273 0 .5.227.5.5s-.227.5-.5.5a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5Z",
  fill: "#44546F"
})));
export default SvgIcExclamationCircleDescription;